import { type IntakeDoc, workspace } from '../../../data/state.js';
import { settledAttachments } from '../../../lib/attachment-processing.js';

export function demandDocuments(): IntakeDoc[] {
  return settledAttachments(Object.values((workspace.value?.filesByKind ?? {}) as Record<string, IntakeDoc[]>).flat());
}

export type DocumentType = {
  target: 'demand' | 'quotation' | 'supporting';
  label: 'Line Items' | 'Quotes' | 'Supplemental';
};

export function documentType(document: IntakeDoc): DocumentType {
  if (document.kind === 'demand') return { target: 'demand', label: 'Line Items' };
  if (document.kind === 'quotation' || document.kind === 'comparison-sheet')
    return { target: 'quotation', label: 'Quotes' };
  return { target: 'supporting', label: 'Supplemental' };
}
